<div class="topbar">
  <div class="topbar-left">
    @if (isUserAuthenticated()) {
      <p-button
        icon="pi pi-bars"
        [text]="true"
        [rounded]="true"
        (onClick)="sidebarToggle.emit()"
        aria-label="Toggle sidebar"
        styleClass="menu-toggle"
      ></p-button>
    }
    <div class="logo-container">
      <img class="logo-img" src="/assets/logo.svg" alt="Youtopia Logo" />
      <span class="app-name">Youtopia</span>
    </div>
    @if (isUserAuthenticated()) {
      <div class="topbar-divider"></div>
      <yt-breadcrumb />
    }
  </div>

  <div class="topbar-right">
    @if (isUserAuthenticated()) {
      <yt-environment-badge />
      <yt-user-menu />
    } @else {
      <p-button severity="secondary" label="Login" [text]="true" [rounded]="true" (click)="login()"></p-button>
    }
  </div>
</div>
